import { API_ENDPOINTS } from "@/api/services/pms/apiEndPoints";
import { baseApi } from "@/utils/baseApi";
import { EmployeeApi } from "../Employee/employeeApi";

export const DivisionHeadApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    dvhSampleDownload: builder.query({
      query: ({ pmsYear, reviewer, repManager }) => {
        const params = new URLSearchParams({
          pmsYear,
          ...(reviewer && { reviewer }),
          ...(repManager && { repManager }),
        }).toString();

        return {
          url: `${API_ENDPOINTS.DIVISIONHEAD.SAMPLE_DOWNLOAD}?${params}`,
          method: "GET",
          responseHandler: (response) => response.blob(),
        };
      },
    }),

    // dhBulkUpload: builder.mutation({
    //     query: (formData) => ({
    //     url: API_ENDPOINTS.DIVISIONHEAD.BULK_UPLOAD,
    //       method: "POST",
    //       body: formData,
    //       responseHandler: (response) => response.text(), // 👈 prevents JSON parse
    //     }),
    // invalidatesTags: ["DH_BULK_UPLOAD"],
    //   }),
    dhBulkUpload: builder.mutation({
      query: ({ formData, checkWeightage = 0 }) => ({
        url: API_ENDPOINTS.DIVISIONHEAD.BULK_UPLOAD(checkWeightage),
        method: "POST",
        body: formData,
        responseHandler: (response) => response.blob(),
      }),
      invalidatesTags: ["pms_list"],
    }),
    masterAllocation: builder.mutation({
      query: (values) => ({
        url: API_ENDPOINTS.DIVISIONHEAD.MASTER(values),
        method: "PUT",
        // body: values.empId,
      }),
      invalidatesTags: ["allocation"],
    }),
    getAllocation: builder.query({
      query: (pmsYear) => {
        return {
          url: `${API_ENDPOINTS.DIVISIONHEAD.GET_ALLOCATION(pmsYear)}`,
          method: "GET",
        };
      },
      providesTags: ["allocation"],
    }),
    getDHList: builder.query({
      query: (pmsYear) => {
        return {
          url: `${API_ENDPOINTS.DIVISIONHEAD.DHLIST(pmsYear)}`,
          method: "GET",
        };
      },
      providesTags: ["allocation"],
    }),
    dhListSampleDownload: builder.mutation({
      query: () => ({
        url: API_ENDPOINTS.DIVISIONHEAD.SAMPLE_DOWNLOAD(),
        method: "GET",
        responseHandler: async (response) => response.blob(),
        extraOptions: { isMultipart: true },
      }),
    }),
    dhBulkUploadMaster: builder.mutation({
      query: ({ formData, pmsYear }) => ({
        url: API_ENDPOINTS.DIVISIONHEAD.DH_BULK_UPLOAD(pmsYear),
        method: "PUT",
        body: formData,
        responseHandler: (response) => response.blob(),
      }),
      invalidatesTags: ["allocation"],
    }),
    dhSaveBulkUpload: builder.mutation({
      query: (formData) => ({
        url: API_ENDPOINTS.DIVISIONHEAD.SAVE_BULK_UPLOAD(),
        method: "PUT",
        body: formData,
        responseHandler: (response) => response.blob(),
      }),
      invalidatesTags: ["allocation, "],
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
          dispatch(EmployeeApi.util.invalidateTags(["pms_list", "DH_Budget"]));
        } catch (error) {
          // console.error("withdrawRegularization failed:", error);
        }
      },
    }),
    dhAutoSave: builder.mutation({
      query: ({ formData, required, checkPromotionWeightage = 0 }) => ({
        url: `${API_ENDPOINTS.ASHR.ASHR_UPDATE_SAVE(required, checkPromotionWeightage)}`,
        method: "PUT",
        body: formData,
      }),
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
          dispatch(EmployeeApi.util.invalidateTags(["DH_Budget"]));
        } catch (error) {
          // console.error("withdrawRegularization failed:", error);
        }
      },
    }),
  }),
});

export const {
  useLazyDvhSampleDownloadQuery,
  useDhBulkUploadMutation,
  useMasterAllocationMutation,
  useGetAllocationQuery,
  useGetDHListQuery,
  useDhListSampleDownloadMutation,
  useDhBulkUploadMasterMutation,
  useDhSaveBulkUploadMutation,
  useDhAutoSaveMutation,
} = DivisionHeadApi;
